import styled from "styled-components";
import { Text } from "@gcs/design-system/react";

export const SectionDataProtectionContainer = styled.section(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const SectionDataProtectionTitle = styled(Text)(({ theme }) => ({
  fontSize: "32px",
  color: theme.color.brandPrimary.light,
  lineHeight: "150%",
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionDataProtectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    gap: "60px",
  },
}));

/* PROFILE */
export const SectionDataProtectionProfile = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%",
  width: "100%",
  gap: "20px",

  [theme.breakpoint.lg()]: {
    maxWidth: "185px",
  },
}));

export const SectionDataProtectionProfileImage = styled.img(() => ({
  maxWidth: "100%",
  width: "100%",
  objectFit: "cover",
}));

export const SectionDataProtectionProfileContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const SectionDataProtectionProfileContentTitle = styled(Text)(
  ({ theme }) => ({
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "150%",
    color: theme.color.brandPrimary.light,

    [theme.breakpoint.lg()]: {
      fontSize: "24px",
    },
  }),
);

export const SectionDataProtectionProfileContentDescription = styled(Text)(
  ({ theme }) => ({
    fontSize: "16px",
    fontWeight: "500",
    color: theme.color.neutral["02"],

    [theme.breakpoint.lg()]: {
      fontSize: "18px",
    },
  }),
);

export const SectionDataProtectionBlock = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",

  [theme.breakpoint.lg()]: {
    gap: "32px",
  },

  p: {
    fontSize: "18px",
    fontWeight: "500",

    [theme.breakpoint.lg()]: {
      fontSize: "20px",
    },
  },
}));
